import { z } from 'zod';
/**
 * Prisma enum'larining oynasi.
 *
 * Qiymatlar `packages/db/prisma/schema.prisma` dan KO'CHIRILGAN, o'ylab
 * topilmagan. Ikkalasi mos kelishini `enums.spec.ts` schema faylini o'qib
 * tekshiradi — enum jimgina ajralib ketmaydi.
 */
export const CUSTOMER_TYPES = ['INDIVIDUAL', 'COMPANY'];
export const CustomerTypeSchema = z.enum(CUSTOMER_TYPES);
export const SUPPLY_TYPES = ['IN_STOCK', 'PRE_ORDER'];
export const SupplyTypeSchema = z.enum(SUPPLY_TYPES);
export const PRODUCT_STATUSES = ['DRAFT', 'ACTIVE', 'ARCHIVED'];
export const ProductStatusSchema = z.enum(PRODUCT_STATUSES);
export const SIZE_CLASSES = ['NORMAL', 'BULKY'];
export const SizeClassSchema = z.enum(SIZE_CLASSES);
export const MEDIA_TYPES = ['IMAGE', 'DOCUMENT'];
export const MediaTypeSchema = z.enum(MEDIA_TYPES);
export const STOCK_MOVE_TYPES = [
    'PURCHASE',
    'SALE',
    'RETURN',
    'TRANSFER_IN',
    'TRANSFER_OUT',
    'ADJUSTMENT',
];
export const StockMoveTypeSchema = z.enum(STOCK_MOVE_TYPES);
export const SHIPMENT_TYPES = ['SHOP', 'CHINA'];
export const ShipmentTypeSchema = z.enum(SHIPMENT_TYPES);
export const PUBLIC_STAGES = [
    'RECEIVED',
    'AT_SUPPLIER',
    'IN_TRANSIT',
    'AT_CUSTOMS',
    'PREPARING',
    'DELIVERING',
    'DELIVERED',
    'CANCELLED',
];
export const PublicStageSchema = z.enum(PUBLIC_STAGES);
export const DELIVERY_METHODS = ['COURIER', 'PICKUP'];
export const DeliveryMethodSchema = z.enum(DELIVERY_METHODS);
/** Standart `SPLIT` — tayyorini darhol yuborish (docs/02-MAHSULOT.md). */
export const SPLIT_PREFERENCES = ['SPLIT', 'TOGETHER'];
export const SplitPreferenceSchema = z.enum(SPLIT_PREFERENCES);
/** MVP standarti — `CASH`. PAYME/CLICK keyin ulanadi. */
export const PAYMENT_METHODS = ['CASH', 'CARD_TRANSFER', 'PAYME', 'CLICK'];
export const PaymentMethodSchema = z.enum(PAYMENT_METHODS);
/**
 * Yangi buyurtmada tanlanadigan usullar (TASK-021). PAYME/CLICK uchun
 * to'lov boshlash va webhook yo'q — ular enumda faqat eski yozuvlarni
 * o'qish uchun qoladi.
 */
export const CHECKOUT_PAYMENT_METHODS = ['CASH', 'CARD_TRANSFER'];
export const CheckoutPaymentMethodSchema = z.enum(CHECKOUT_PAYMENT_METHODS);
export const PAYMENT_STATUSES = ['PENDING', 'CONFIRMED', 'REJECTED', 'REFUNDED'];
export const PaymentStatusSchema = z.enum(PAYMENT_STATUSES);
/** Rol do'kon ko'lami (TASK-007-A, D05). Bazada `NULL` — tasniflanmagan. */
export const ROLE_SCOPES = ['GLOBAL', 'SHOP'];
export const RoleScopeSchema = z.enum(ROLE_SCOPES);
export const LOCALES = ['UZ', 'RU'];
//# sourceMappingURL=enums.js.map